import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import teamReducer from '../features/team/teamSlice';
import playerProfileReducer from '../features/playerProfile/playerProfileSlice';
import coachProfileReducer from '../features/coach/coachProfileSlice';
import scoutProfileReducer from '../features/scout/scoutProfileSlice';
import paymentReducer from '../features/payment/paymentSlice';
import adminReducer from '../features/admin/adminSlice';
import gameReducer from '../features/game/gameSlice';
import scrapeJobReducer from '../features/scrapeJob/scrapeJobSlice';
import videoClipReducer from '../features/videoClip/videoClipSlice';
import notificationReducer from '../features/notification/notificationSlice';
import messagingReducer from '../features/messaging/messagingSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    team: teamReducer,
    playerProfile: playerProfileReducer,
    coachProfile: coachProfileReducer,
    scoutProfile: scoutProfileReducer,
    payment: paymentReducer,
    admin: adminReducer,
    game: gameReducer,
    scrapeJob: scrapeJobReducer,
    videoClip: videoClipReducer,
    notification: notificationReducer,
    messaging: messagingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
